import styled from 'styled-components'

export const ProductBox = styled.div`
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  height: auto;
  background-color: #d5e4e6;
  box-shadow: 0px 20px 40px -25px rgba(191, 191, 191, 0.5);
  cursor: pointer;
  overflow: auto;
  transition: all 0.25s ease-in-out;
  ${(props) => props.gridArea && `grid-area: ${props.gridArea}`};
  ${(props) =>
    props.disabled &&
    `
    opacity: 0.5;
    filter: grayscale(90%);
    cursor: auto;
    box-shadow: 0px 20px 40px -25px rgba(191, 191, 191, 0.5);
  `};
`

export default ProductBox



// WEBPACK FOOTER //
// ./src/components/containers/configurator/ProductBox.tsx